// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oQLS","select":"styles_select__2crQd"};